import { createSelector } from 'reselect';
import { getFAIEnabled } from './getFAIEnabled';
import { getFAICurrentInspection } from './getFAICurrentInspection';
import { getFAIHasActiveInspection } from './getFAIHasActiveInspection';
import { getFAIApproved } from './getFAIApproved';
import { getFAIRejected } from './getFAIRejected';
import { getIsPaused } from './getIsPaused';

const getFAIBannerVisible = createSelector(
  [
    getFAIEnabled,
    getFAIApproved,
    getFAIRejected,
    getFAICurrentInspection,
    getFAIHasActiveInspection,
    getIsPaused,
  ],
  (
    faiEnabled,
    approved,
    rejected,
    currentInspection,
    hasActiveInspection,
    isPaused
  ) => {
    if (!faiEnabled || !currentInspection || isPaused) return false;
    return hasActiveInspection || approved || rejected;
  }
);

export { getFAIBannerVisible };
